export enum EAttachmentType {
  Upload = 'upload',
  File = 'file',
  External = 'external',
  Document = 'document',
}
